"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTitleText = exports.ErrorText = exports.TitleText = exports.BodyText = exports.Text = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var Text_1 = __importDefault(require("./Text"));
exports.Text = Text_1.default;
var BodyText = (0, styled_components_1.default)(Text_1.default).attrs(function (props) { return (__assign({ size: 16 }, props)); })(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
exports.BodyText = BodyText;
var ErrorText = (0, styled_components_1.default)(Text_1.default).attrs(function (props) { return ({
    tag: "p",
    size: 12,
    color: props.theme.oldColors.traffic.alertRed
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
exports.ErrorText = ErrorText;
var TitleText = (0, styled_components_1.default)(Text_1.default).attrs({
    size: 24,
    bold: true,
    tag: "h1"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
exports.TitleText = TitleText;
var PageTitleText = (0, styled_components_1.default)(Text_1.default).attrs(function (props) { return ({
    size: 32,
    bold: true,
    color: props.theme.oldColors.primary.purple
}); })(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
exports.PageTitleText = PageTitleText;
exports.default = Text_1.default;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
